<template>
  <div
    class="box"
    :class="{
      open: isBoxOpen,
      isFirstCollapse,
      isLastCollapse,
      'green-border': withGreenBorder && isBoxOpen,
    }"
    :style="{ backgroundColor: collapseColor }"
  >
    <div class="preview-wrapper" @click="isBoxOpen = !isBoxOpen">
      <slot name="preview" v-if="$slots.preview"></slot>
      <p v-else>
        <span v-if="questionNumber" class="question-number"
          >{{ questionNumber }}:</span
        >
        {{ question }}
      </p>
      <img
        v-if="!isBoxOpen"
        class="arrow-down"
        src="@/assets/images/icons/icons-arrow-down.svg"
        alt="icon"
      />
      <img
        v-else
        class="arrow-up"
        src="@/assets/images/icons/icons-arrow-up.svg"
        alt="icon"
      />
    </div>
    <div class="detail-wrapper" v-if="isBoxOpen">
      <slot name="detail" v-if="$slots.detail"></slot>
      <p v-html="answer" v-else-if="!link" />
      <p v-else>
        {{ answerFirstPart }}
        <router-link :to="link">{{ linkName }}</router-link>
        {{ answerSecondPart }}
      </p>
      <slot name="actions"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Collapse',
  props: {
    questionNumber: Number,
    question: String,
    answer: String,
    answerFirstPart: String,
    answerSecondPart: String,
    link: String,
    linkName: String,
    isFirstCollapse: Boolean,
    isLastCollapse: Boolean,
    onDetailOpen: Function,
    withGreenBorder: Boolean,
    isInitiallyOpen: {
      type: Boolean,
      default: false,
    },
    collapseColor: {
      type: String,
      default: '#FFFFFF',
    },
  },
  data() {
    return {
      isBoxOpen: this.$props.isInitiallyOpen,
    };
  },
  watch: {
    isBoxOpen(newValue) {
      newValue && this.onDetailOpen && this.onDetailOpen();
    },
  },
  created() {
    if (this.isBoxOpen) {
      this.onDetailOpen && this.onDetailOpen();
    }
  },
};
</script>

<style scoped lang="scss">
@import '@/assets/styles/variables.scss';

.box {
  width: 100%;
  border: 1px solid $gray-4;
  border-bottom: none;
  cursor: pointer;
  user-select: none;
  letter-spacing: -0.05px;
  color: $dark-gray-5;
  margin-bottom: 10px;
  border-radius: 10px;

  a {
    color: $blue-1;
  }

  &.open {
    box-shadow: 0 3px 14px 2px rgba(31, 31, 31, 0.06),
      0 8px 10px 1px rgba(31, 31, 31, 0.08),
      0 5px 5px -3px rgba(31, 31, 31, 0.06);
    border-radius: 10px;

    &.green-border {
      border: 1px solid $green-2;
    }

    .question {
      padding-bottom: 0;

      p {
        font-weight: bold;
        letter-spacing: -0.2px;
      }
    }
  }

  .preview-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0 16px;
    padding: 15px 0;

    p {
      font-size: 16px;
      font-weight: normal;
      color: $gray-6;

      span {
        display: inline-flex;
      }
    }
  }

  .detail-wrapper {
    margin: 0 16px;
    padding-bottom: 18px;
    line-height: 20px;

    p {
      font-size: 14px;
      color: $gray-6;

      :deep(ul) {
        margin-bottom: 40px;

        ul {
          padding-left: 25px;
        }

        li {
          display: flex;
          align-items: baseline;

          &:before {
            content: '·';
            color: $gray-6;
            margin-right: 20px;
            transform: scale(2.2);
          }

          p {
            margin: 0;
          }

          &.noListStyle {
            &:before {
              display: none;
            }
          }
        }
      }
    }
  }

  &.isFirstCollapse {
    border-radius: 10px;
  }

  &.isLastCollapse {
    border-radius: 10px;
    border-bottom: 1px solid $gray-4;
  }
}
</style>
